var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDjibouti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2608 21.7391C18.2608 21.7391 5.86951 5.85508 5.85779 5.85789C9.47701 2.23859 14.4771 0 20 0C31.0456 0 40 8.95437 40 20L18.2608 21.7391Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2608 20C18.2608 20 5.86951 34.1449 5.85779 34.1421C9.47701 37.7614 14.4771 40 20 40C31.0456 40 40 31.0456 40 20H18.2608Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85785 5.85779C-1.95262 13.6683 -1.95262 26.3316 5.85785 34.1422C9.08543 30.9146 12.1896 27.8104 20 20L5.85785 5.85779Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0945 14.7826L9.38942 18.7682H13.5805L10.19 21.2317L11.4849 25.2174L8.0945 22.7541L4.70395 25.2174L5.99911 21.2317L2.60864 18.7682H6.79942L8.0945 14.7826Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjibouti);
export default __webpack_public_path__ + "static/media/djibouti.6b5941b479743700ef7911cbc47ed699.svg";
export { ForwardRef as ReactComponent };